import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgForward = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5 17.15L22.5 12.15V26.45C22.5 26.8833 22.6417 27.2417 22.925 27.525C23.2083 27.8083 23.5667 27.95 24 27.95C24.4333 27.95 24.7917 27.8083 25.075 27.525C25.3583 27.2417 25.5 26.8833 25.5 26.45V12.1L30.55 17.1C30.85 17.4 31.2 17.55 31.6 17.55C32 17.55 32.35 17.4 32.65 17.1C32.95 16.8 33.1 16.45 33.1 16.05C33.1 15.65 32.9667 15.3167 32.7 15.05L25.1 7.45C24.9333 7.28333 24.7667 7.16667 24.6 7.1C24.4333 7.03333 24.25 7 24.05 7C23.85 7 23.6667 7.03333 23.5 7.1C23.3333 7.16667 23.1667 7.28333 23 7.45L15.45 15C15.15 15.3 15 15.65 15 16.05C15 16.45 15.15 16.8 15.45 17.1C15.75 17.4 16.1 17.55 16.5 17.55C16.9 17.55 17.2333 17.4167 17.5 17.15Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.5 23.001V19.6275L5.81398 26.6661C5.31418 26.9231 5 27.438 5 28C5 28.562 5.31418 29.0769 5.81398 29.3339L22.3993 37.8635C23.4039 38.3802 24.5961 38.3802 25.6007 37.8635L42.186 29.3339C42.6858 29.0769 43 28.562 43 28C43 27.438 42.6858 26.9231 42.186 26.6661L28.5 19.6275V23.001L38.2202 28L24.2287 35.1956C24.0852 35.2695 23.9148 35.2695 23.7713 35.1957L9.77978 28L19.5 23.001Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.5 19.6275V23.001L9.77978 28L23.7713 35.1957C23.9148 35.2695 24.0852 35.2695 24.2287 35.1956L38.2202 28L28.5 23.001V19.6275L42.186 26.6661C42.6858 26.9231 43 27.438 43 28C43 28.562 42.6858 29.0769 42.186 29.3339L25.6007 37.8635C24.5961 38.3802 23.4039 38.3802 22.3993 37.8635L5.81398 29.3339C5.31418 29.0769 5 28.562 5 28C5 27.438 5.31418 26.9231 5.81398 26.6661L19.5 19.6275Z",
			fill: "currentColor"
		})
	]
});
export default SvgForward;
